// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Table----index-module---root---9FzgZ","table":"src-components-Table----index-module---table---2bbYv","tr":"src-components-Table----index-module---tr---3VNJw","td":"src-components-Table----index-module---td---dBP0-","th":"src-components-Table----index-module---th---251SE","tbody":"src-components-Table----index-module---tbody---3ZFAd","button":"src-components-Table----index-module---button---20o9M","footer":"src-components-Table----index-module---footer---1OSRp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Table/index.module.css
// module id = 620
// module chunks = 168707334958949